var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.errors, function(item, index) {
        return _c(
          "v-alert",
          {
            key: index,
            attrs: { type: "error", outlined: "", dismissible: "" }
          },
          [_c("span", [_vm._v(_vm._s(item.first()))])]
        )
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [_c("create-order-status", { ref: "create-order-status" })],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [_c("table-order-status", { ref: "table-order-status" })],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }